import script from "./ShortUrl.vue?vue&type=script&lang=js"
export * from "./ShortUrl.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__